<template>

  <div :class="collapse ? 'menu-bar-collapse-width' : 'menu-bar-container'" v-if="!collapse">
    <menu-tree
      v-for="item in navTreeChild"
      :key="item.id"
      :menu="item"
    ></menu-tree>
  </div>
  <!-- <el-menu
		ref="navmenu"
		:default-active="`${$route.meta.index}`"
		:class="`${collapse?'menu-bar-collapse-width':'menu-bar-width'} ${minCollapse?'menu-h5-width':''}`"
		:collapse="collapse"
		:collapse-transition="true"
		:unique-opened="true" 
		text-color="#606266"
		:popper-append-to-body="true"
	>
		导航菜单树组件，动态加载菜单
		<menu-tree v-for="item in navTree" :key="item.id" :menu="item"></menu-tree>
	</el-menu> -->
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  components: {
  },
  computed: {
    ...mapState({
      appName: (state) => state.app.appName,
      collapse: (state) => state.app.collapse,
      navTree: (state) => state.menu.navTree,
      navTreeChild: (state) => state.menu.navTreeChild,
    }),
    mainTabs: {
      get() {
        return this.$store.state.tab.mainTabs;
      },
      set(val) {
        this.$store.commit("updateMainTabs", val);
      },
    },
    mainTabsActiveName: {
      get() {
        return this.$store.state.tab.mainTabsActiveName;
      },
      set(val) {
        this.$store.commit("updateMainTabsActiveName", val);
      },
    },
  },
  watch: {
    $route: "handleRoute",
  },
  created() {
    this.handleRoute(this.$route);
  },
  methods: {
    // 路由操作处理
    handleRoute(route) {
      // tab标签页选中, 如果不存在则先添加
      var tab = this.mainTabs.filter((item) => item.name === route.name)[0];
      if (!tab) {
        tab = {
          name: route.name,
          title: route.name,
          icon: route.meta.icon,
        };
        this.mainTabs = this.mainTabs.concat(tab);
      }
      this.mainTabsActiveName = tab.name;
      // 切换标签页时同步更新高亮菜单
      if (this.$refs.navmenu != null) {
        this.$refs.navmenu.activeIndex = "" + route.meta.index;
        this.$refs.navmenu.initOpenedMenu();
      }
    },
  },
};
</script>

<style scoped lang="scss">
$navColor: #fff;
.menu-bar-container {
  width: 200px;
  position: fixed;
  top: 60px;
  left: 0;
  z-index: 98;
  background-color: $navColor;
  height: calc(100vh - 60px);
  box-shadow: 3px 0px 4px 0px rgba(0, 0, 0, 0.06);
  .menu-bar-ul {
    // padding: 16px 0 24px;
    height: 100%;
    box-sizing: border-box;
    // overflow: auto;
    background-color: $navColor;
  }
  .bottomfold {
    width: 100%;
    height: 36px;
    margin-top: 200px;
    box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.06);
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
    position: absolute;
    bottom: 4px;
    .bottomfoldIcon {
      margin-right: -85%;
      width: 16px;
      height: 16px;
      color: #2492fc;
      background-size: 100%;
      background-image: url("../../../assets/img/left.png");
      background-repeat: no-repeat;
      background-position: center 50%;
    }
  }
}
.menu-bar-collapse-width {
  width: 0px;
  position: fixed;
  top: 60px;
  left: 0;
  z-index: 98;
  background-color: $navColor;
  height: calc(100vh - 60px);
  box-shadow: 3px 0px 4px 0px rgba(0, 0, 0, 0.06);
  .menu-bar-ul {
    // padding: 16px 0 24px;
    height: 100%;
    box-sizing: border-box;
    // overflow: auto;
    background-color: $navColor;
  }
  .bottomfold {
    width: 100%;
    height: 36px;
    margin-top: 200px;
    box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.06);
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    justify-content: center;
    position: absolute;
    bottom: 4px;
    .bottomfoldIcon {
      margin-right: -85%;
      width: 16px;
      height: 16px;
      color: #2492fc;
      background-size: 100%;
      background-image: url("../../../assets/img/left.png");
      background-repeat: no-repeat;
      background-position: center 50%;
    }
  }
}
.placement {
  position: fixed;
  top: 70px;
  left: 2px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.12), 0 0 10px rgba(0, 0, 0, 0.06);
  display: none;
}
.fold {
  display: none;
}
@media screen and (max-width: 1366px) {
  .menu-bar-width {
    width: 200px;
  }
}
@media screen and (max-width: 992px) {
  .menu-bar-container {
    top: 60px;
    z-index: 110;
    height: calc(100vh - 60px);
  }
  .menu-bar-width {
    width: 0px;
  }
  .media-show {
    width: 200px;
  }
  .fold {
    display: block;
  }
  .h5-container {
    right: 0;
    background: rgba(0, 0, 0, 0.3);
  }
}
</style>